<template>
  <v-navigation-drawer app class="sidebar__main" width="350" v-model="drawer">
    <div class="box-sidebar-logo mb-5">
      <img class="logo-img" src="../../assets/Logosisvocbranca.svg" alt="" />
      <h3 class="text-logo" />
      <h6 class="text-system-name" />
      <div id="example" />
    </div>

    <!-- <section class="logo">
      <h3>SISCOV</h3>
      <small>Sistema de Controle de Visitantes </small>
    </section> -->

    <section class="card__menu" width="300">
      <h6 class="text__indicator">Menu</h6>

      <section class="menu__list">
        <router-link
          class="list__item"
          active-class="list__item-active"
          to="/dashboard"
        >
          <v-icon size="18" class="icon"> mdi-view-dashboard-outline </v-icon>
          <span>Dashboard</span>
        </router-link>

        <v-list-item-group v-if="validationPermission('list_log')">
          <router-link
            to="/log"
            class="list__item"
            active-class="list__item-active"
          >
            <v-icon size="22" class="icon"> mdi-history </v-icon>
            <span>Log de Usuários</span>
          </router-link>
        </v-list-item-group>

        <v-list-group v-if="validationPermission('list_visitor') || validationPermission('list_movement_visitor')">
          <template v-slot:activator>
            <!-- <div class="group__list"> -->
            <v-icon size="18" class="icon"> mdi-calendar-month </v-icon>
            <v-list-item-title
              class="v-list-item-title list__item"
            >Visitante/ Acompanhante</v-list-item-title>
            <!-- </div> -->
          </template>

          <div class="group__item">
            <router-link
              class="list__item"
              active-class="list__item-active"
              to="/person"
              v-if="validationPermission('create_visitor')"
            >
              <span class="subitem-tittle">Registrar Entrada</span>
            </router-link>
            <router-link
              class="list__item"
              active-class="list__item-active"
              to="/PesquisarMovi"
              v-if="validationPermission('list_movement_visitor')"
            >
              <span class="subitem-tittle">Movimentação</span>
            </router-link>
          </div>
        </v-list-group>

        <v-list-group v-if="validationPermission('list_person_admintrative') || validationPermission('list_visit_sector')">
          <template v-slot:activator>
            <v-icon size="20" class="icon"> mdi-account-circle-outline </v-icon>

            <v-list-item-title class="v-list-item-title list__item"
              >Visita Administrativa</v-list-item-title
            >
            <!-- </div> -->
          </template>

          <div class="group__item">
            <router-link
              class="list__item"
              active-class="list__item-active"
              to="/adm-person"
              v-if="validationPermission('list_person_administrative')"
            >
              <span class="subitem-tittle">Visitante Administrativo</span>
            </router-link>

            <router-link
              class="list__item"
              active-class="list__item-active"
              to="/visitSector"
              v-if="validationPermission('list_visit_sector') && $store.state.authUser.id_profile_user !== '3'"
            >
              <span class="subitem-tittle">Setor Visitante</span>
            </router-link>

            <!-- <router-link
              class="list__item"
              active-class="list__item-active"
              to="/visitantType"
            >
              <span class="subitem-tittle">Tipo de Visitante</span>
            </router-link> -->
          </div>
        </v-list-group>

        <v-list-group  v-if="validationPermission('edit_user') || validationPermission('edit_profile')">
          <template v-slot:activator>
            <!-- <div class="group__list">  -->
            <v-icon size="20" class="icon"> mdi-table-large-plus </v-icon>
            <v-list-item-title class="v-list-item-title list__item">
              Cadastro Básico</v-list-item-title
            >
            <!-- </div> -->
          </template>

          <div class="group__item">
            <router-link
              to="/users"
              class="list__item"
              active-class="list__item-active"
              v-if="validationPermission('edit_user')"
            >
              <span class="subitem-tittle">Usuários</span>
            </router-link>
            
            <router-link
              to="/perfis"
              class="list__item"
              active-class="list__item-active"
              v-if="validationPermission('edit_profile')"
            >
              <span class="subitem-tittle">Perfil</span>
            </router-link>

          </div>
        </v-list-group>
      </section>
    </section>
  </v-navigation-drawer>
</template>
<script>

import axios from "@/axios";
import PermissionMixin from "@/mixins/verificationPermissions";


export default {

  mixins: [PermissionMixin],
  data() {
    return {
      drawer: null,
    };
  },

  props: {
    resource: {
      type: Boolean,
    },
  },

  // watch:{
  //  " $store.state.authUser"(newVal) {
  //     if(newVal?.permissions)
  //     console.log(newVal.permissions);
  //   }
  // },

  created() {
    if (this.$route.path !== "/person") {
      this.$store.state.stepperPatient = true;
      this.$store.state.stepperVisitors = false;
    }
    // const userData = settingDecryption =("userData", "@qG56W5w04YI");
      // Mostra no console os dados do usuário logado
    // console.log(this.$store.state.authUser);
    
  },
  methods: {
    // hasPermission(permission) {
    //   console.log(this.$store.state.authUser.permissions);
    //   console.log(permission);
    //   return this.$store.state.authUser.permissions?.includes(permission);
      
    // },
    downloadDeclaration() {
      var obj = { download: "DECLARACAO_DE_COMPARECIMENTO_RATIFICADO.pdf" };
      axios
        .get(
          "/downloads",
          {
            params: {
              ...obj,
            },
          },
          { responseType: "blob" }
        )
        .then((res) => {
          var docUrl = document.createElement("a");
          docUrl.href = res.data;
          docUrl.setAttribute("download", "declaracao_comparecimento.pdf");
          document.body.appendChild(docUrl);
          docUrl.click();
        });
    },
  },
  watch: {
    resource: function () {
      this.drawer = !this.drawer;
    },
  },
};
</script>

<style lang="scss">
.v-navigation-drawer__border {
  width: 0px !important;
}

.main-content {
  background: #ffffff !important;
  padding: 20px !important;
  border-radius: 10px !important;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* sombra opcional */
  min-height: 350px; /* altura mínima opcional */
}
// atura do mesmo tamanho do card menu

// .container > .main-content {
//   background: #ffffff !important;
//   padding: 20px !important;
//   border-radius: 10px !important;
// }

  
.sidebar {
  background: transparent;
  padding: 0, 01px;
  border-radius: 0px;
  border: 1px solid red;
  
}

.sidebar__main {
  background: transparent !important;
  padding: 20px;


  .logo {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px 8px 0 0;
    padding: 15px 0;
    min-height: 64px;
    text-align: center;
    background: #ffffff;
    

    h3 {
      font-family: "Audiowide", cursive;
      font-size: 22px;
      color: #1876d2;
      
    }
  }

  .card__menu {
    padding: 10px;
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    // border: 1px solid red;
    // height: 80%;
    


    .text__indicator {
      font-family: "Poppins", sans-serif;
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      margin-bottom: 15px;
      
    }

    .menu__list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      

      // 1-//lista de grupos
      .list__item {
        display: flex;
        align-items: center;
        gap: 1px;
        height: 45px;
        padding: 15px 10px;
        text-decoration: none;
        transition: 0.8s;
        border-radius: 10px;

        .icon {
          // border: 1px solid red;
          color: #666666 !important;
        }
        .subitem-tittle {
          color: #666666;
          font-weight: 400;
          font-size: 12px;


        }

        //span log
        span {
          color: #666666;
          font-weight: 600;
          font-size: 12px;
        }
      }

      .list__item:hover {
        background: #8fe0c8 !important;
        border-radius: 10px;
        transition: 0.8s;
      }
// fundo qdo é clicado o item
      .list__item-active{
        background:#d9f9f0 ;
        border-radius: 10px;

        .icon {
          color: #013d3a !important;
          // border: solid 1px green
        }

        // span log de usuarios
        span {
          color: #013d3a;
          font-weight: 600;
          font-size: 12px;
        }
      }
    }

    // .group__list {
    //   display: flex;
    //   align-items: center;
    //   gap: 5px;

    //   .icon {
    //     color: #666666 !important;
    //     border: 1px solid blue;
    //   }

    //     }


    .v-list-group .v-list-item__content {
      display: flex;
      align-items: center;
      gap: 10px;


      /* espaço entre ícone e texto */
    }

    .v-list-group .v-list-item__prepend {
      margin-right: 10px;

      
      /* garante afastamento do ícone */
    }

    .group__item {
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin: 0 0 0 10px;
      
      
    }
  }
}

// ajusta os nomes dos grupos
.v-list-item-title {
  white-space: normal !important;
  /* Permite quebra de linha */
  overflow: visible !important;
  /* Permite mostrar o texto excedente */
  text-overflow: unset !important;
  font-size: 12px !important;
  margin-left: 3px;
  color: #666666;


  
  // word-break: break-word;
}

.box-sidebar-logo {
  display: flex;
   width: 100%; 
  align-items: center;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  background: linear-gradient(
    to bottom right,
    rgb(14, 0, 141),
    rgb(0, 136, 84)
  ) !important;
  border-radius: 0rem;
  min-height: 20px;
  
}

.logo-img {
  height: 95x;
  width: 260px;

}

.text-logo {
  font-family: "Poppins", sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: #ffffff;

}

.text-system-name {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  
}


.text-section-menu {
  font-family: "Poppins", sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 20px;

}

.list-group {
  display: flex;
  flex-direction: column;
  
}

.link {
  padding: 10px;
  margin: 5px 0;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: 0.8s;
}

.link:hover {
  background: #b28fe0;
  border-radius: 10px;
  transition: 0.8s;
}

.declaration {
  padding: 10px;
  margin: 5px 0;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: 0.8s;
}

.declaration:hover {
  background: #8fe0c8;
  border-radius: 10px;
  transition: 0.8s;
}

// .link > .icon {
//   margin-right: 4px;
//   color: yellow !important;
// }

// .link > span {
//   font-family: "Poppins", sans-serif;
//   font-size: 13px;
//   font-weight: 500;
//   color: #000000;
// }
 
// .link-ativo {
//   background: #cde6ff;
//   border: 1px solid #fafafa;
//   border-radius: 10px;
//   color: rgb(177, 0, 0);
// }

// .submenu-header {
//   font-family: "Poppins", sans-serif;
//   font-size: 14px !important;
//   font-weight: 500;
//   color: #000000;
// }

/* Mobile */
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%) !important;
  background: rgb(248, 248, 248) !important;
}

/* Ícones do menu (links e grupos) */
.list__item .icon,
.v-list-group .v-list-item__prepend .icon {
  margin-right: 12px;
  /* afasta ícone do texto */
  color: #666666 !important;
  font-size: 18px;
  /* mantém tamanho consistente */
  flex-shrink: 0;
  /* evita que o ícone seja comprimido */
}

.v-list-item {
  padding: 15px 10px !important;
  height: 45px !important;
  max-height: 45px !important;
  cursor: pointer;
  transition: 0.8s;
  
}

.v-list-item:hover {
  background:#8fe0c8 !important;
  border-radius: 10px;
  transition: 0.8s;
}


// .v-list-item-title:hover {
//   color: #227760; /* ou qualquer cor desejada */
// }

//estilo das letras quando o item é clicado
.v-list-item-title:hover,
.v-list-item-title:active,
.v-list-item.v-list-item--active .v-list-item-title {
 color: #259c7c !important;
  font-weight: bold;
}
//estilo das letras quando o item é clicado

.v-list-item-icon:hover,
.v-list-item-icon:active,
.v-list-item.v-list-item--active .v-list-item-icon {
  color: #259c7c !important;
}


.theme--light.v-list-item--active:focus::before,
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before,
.theme--light.v-list-item:focus::before,
.theme--light.v-list-item:hover::before,
.theme--light.v-list-item:focus::before {
  opacity: 0 !important;
}


</style>
